import { render, staticRenderFns } from "./ContactsStatistics.vue?vue&type=template&id=031d0e72&scoped=true"
import script from "./ContactsStatistics.vue?vue&type=script&lang=js"
export * from "./ContactsStatistics.vue?vue&type=script&lang=js"
import style0 from "./ContactsStatistics.vue?vue&type=style&index=0&id=031d0e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d0e72",
  null
  
)

export default component.exports